import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class HelpDocumentService extends Service {
	constructor(injector: Injector) {
		super("HelpDocument", injector);
	}

	// API
	search(keywords: string) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/Search/${keywords}`);
	}
}